import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IAsset } from './asset.interface';
import { AssetConfig } from './asset-config.interface';
import { ModalPromptService } from '../../shared/helper-components/modal-prompt.service';

import { AssetImageProcessing } from './asset-image-processing.service';
import { AssetDocumentProcessing } from './asset-document-processing.service';
import { AppUtils } from '../../shared/utils';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/internal/operators/first';
@Component({
    selector: 'clearance-image',
    standalone: false,
    templateUrl: 'clearance-item-image.component.html',
    providers: [
        AssetImageProcessing,
        AssetDocumentProcessing
    ]
})

export class ClearanceItemAssetBaseComponent implements OnDestroy, OnInit, OnChanges {
    ngOnInit(): void {
        this.bindFormValueChanges();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['assetItemForm'] || changes['group']) {
            this.bindFormValueChanges();
        }
    }

    ngOnDestroy(): void {
        this.loadingSub?.unsubscribe();
        this.downloadingSub?.unsubscribe();
        if (this.promptSubscription && !this.promptSubscription.closed)
            this.promptSubscription.unsubscribe();
    }

    get isLoading(): boolean {
        return !!this.assetItemForm?.get('loading')?.value;
    }

    private bindFormValueChanges(): void {
        this.loadingSub?.unsubscribe();
        this.downloadingSub?.unsubscribe();
        if (!this.assetItemForm) {
            return;
        }
        const loading = this.assetItemForm.get('loading');
        if (loading) {
            this.loadingSub = loading.valueChanges.subscribe(() => {
                this._cdr.detectChanges();
            });
        }
        const downloading = this.assetItemForm.get('downloading');
        if (downloading) {
            this.downloadingSub = downloading.valueChanges.subscribe(v => {
                if (!v) {
                    this.unsetClass('value change');
                }
                this._cdr.detectChanges();
            });
        }
    }

    @ViewChild('assetThumbnail', { static: false }) thumbnail: ElementRef;
    //@ViewChild(ModalPromptComponent) private modal: ModalPromptComponent;

    config: AssetConfig;

    @Input('group')
    public assetItemForm: FormGroup;
    @Input('current')
    public current: number;
    @Input('hideReportDefaultIcons')
    public hideReportDefaultIcons: boolean;
    @Input()
    public preventRemoval: boolean;  
    @Output() setDefault = new EventEmitter<FormGroup>()
    @Output() remove = new EventEmitter<number>()
    @Output() enlarge = new EventEmitter<FormGroup>()
    @Output() showOnReport = new EventEmitter<FormGroup>()
    @Output() download = new EventEmitter<FormGroup>()

    public largeImage: string;
    thumbnailIsClicked: boolean = false;
    directDownloading:boolean=false;
    private loadingSub: Subscription;
    private downloadingSub: Subscription;

    constructor(
        private _prompt: ModalPromptService,
        private _cdr: ChangeDetectorRef
    ){}

    setClass(e) {
        this.thumbnailIsClicked = true;
    }

    unsetClass(msg: string = '') {
        this.thumbnailIsClicked = false;
    }

    stopPropagation(e): void {
        e.stopPropagation();
    }

    setDefaultItem(event) {
        this.setDefault.next(event);
        return false;
    }

    promptSubscription: Subscription;

    removeItem($event) {
        this.promptSubscription = this._prompt.openModal(this.deleteAsset, this.current).pipe(first()).subscribe(r=>{
            if (r){
                //this.remove.next(r);
                console.log('item #:' + r + ' was removed');
            }
        });
        return false;
    }

    showItemOnReport($event) {
        this.showOnReport.next($event);
        return false;
    }

    downloadItem(asset, e) {
        this.download.next(asset);
        e.stopPropagation();
        
        return false;
    }

    showFullSize(e) {
        this.enlarge.next(e);
        return false;
    }

    deleteAsset = (param: number) : boolean => {
        this.remove.next(param);
        return true;
    }

    openInNew(e){
        var template = AppUtils.openInNewTemplate();
        var imageWindow = window.open();
        var imageDocument = imageWindow.document.open();
        var deviceHeight =  window.innerHeight * 0.97;
        var deviceWidth =  window.innerWidth * 0.97;
        template = template
                    .replace('{{IMAGE_NAME}}',e.value.name)
                    .replace('{{IMAGE_SOURCE}}',e.value.originalImageFullUrl)
                    .replace('{{DEVICE_HEIGHT}}',deviceHeight.toString())
                    .replace('{{DEVICE_WIDTH}}',deviceWidth.toString());
        imageDocument.write(template);
        imageDocument.close();
    }
}